module.exports = __webpack_public_path__ + "static/media/mountain_wide.9af1eea6.png";